// What happens when the scheme paid MORE than the matched invoice line owes.
//
// The mirror image of ShortfallPrompt. One ERA line pays one invoice line, so
// an over-payment cannot spill onto another line; the remainder either banks
// as unallocated funds on the account or is deliberately left unrecorded.
// Confirm stays blocked until the user has said which. Same secondary-picker
// treatment as the shortfall options (CLAUDE.md 1.4).

import React from "react";
import { Button } from "react-bootstrap";
import { zar } from "../Accounts/lineAllocation";

export const SURPLUS_ACTIONS = Object.freeze({
  UNALLOCATED: "unallocated",
  IGNORE: "ignore",
});

const OPTIONS = [
  {
    action: SURPLUS_ACTIONS.UNALLOCATED,
    label: "Move to unallocated funds",
    hint: "The remainder banks on the account, available to allocate to other invoices.",
  },
  {
    action: SURPLUS_ACTIONS.IGNORE,
    label: "Ignore",
    hint: "The remainder is not recorded. The receipt is written for the applied amount only.",
  },
];

export default function SurplusPrompt({ surplus, action, onSetAction }) {
  if (!(surplus > 0)) return null;

  return (
    <div className="mb-0">
      <p className="small text-muted">
        The scheme paid {zar.format(surplus)} more than this line owes. Decide
        what happens to the remainder before confirming.
      </p>
      <div className="d-flex flex-wrap gap-2">
        {OPTIONS.map((o) => (
          <Button
            key={o.action}
            size="sm"
            style={{ minWidth: 150 }}
            variant={action === o.action ? "secondary" : "outline-secondary"}
            aria-pressed={action === o.action}
            onClick={() => onSetAction(o.action)}
          >
            {o.label}
          </Button>
        ))}
      </div>
      <div className="small text-muted mt-2">
        {OPTIONS.find((o) => o.action === action)?.hint || "Choose one to continue."}
      </div>
    </div>
  );
}
